import BaseDataObject from './BaseDataObject';

export default class CreateBetParameters extends BaseDataObject {
  setBetKey(betKey) {
    this.setObject('betKey', betKey);
  }

  setBetConfig(betConfig) {
    this.setObject('betConfig', betConfig);
  }
}
